import { type UseMutationResult, useMutation } from 'react-query';
import {
  PptAccessListIssuerService,
  type ResponseDto_ImportPptAccessListResponseDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const usePostPptAccessListImport = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
): UseMutationResult<ResponseDto_ImportPptAccessListResponseDto | undefined, unknown, File, unknown> => {
  return useMutation(async (file: File) =>
    handleRequest(
      PptAccessListIssuerService.postApiCustomerApiAppPptAccessListIssuerImport({
        ImportFile: file,
      }),
    ),
  );
};

export default usePostPptAccessListImport;
